import './style.scss';
import React, { useState } from 'react';
import ChallengeList from '../ChallengeList';

const ChallengeModal = ({
  allData,
  companyData,
  userName,
  userid,
  challengeSentTo,
  callback = () => {
  },
}) => {
  const styless = {
    cancelBtnWrapper: {
      position: 'absolute',
      right: 15,
      top: 15,
      cursor: 'pointer',
    },
    cancelIcon: {
      color: '#fff',
      fontSize: 30,
    },
    linkStyle: {
      cursor: 'pointer',
      margin: 15,
      padding: 5,
    },
  };

  const [showCompnany, set_showCompany] = useState(true);
  const [showGlobal, set_showGlobal] = useState(false);

  const renderChallengeLists = () => {
    return (
      <div
        className='simulated_results challenge-list-container'
        style={{ border: 'none', borderRadius: 0 }}
      >
        {showCompnany && (
          <ChallengeList
            data={companyData}
            userName={userName}
            send_or_recieve={'send'}
            challengeSentTo={challengeSentTo}
          />
        )}
        {showGlobal && (
          <ChallengeList
            data={allData}
            userName={userName}
            send_or_recieve={'send'}
            challengeSentTo={challengeSentTo}
          />
        )}
      </div>
    );
  };

  return (
    <>
      <div className='modal model-lg'>
        <div className='modal-overlay'></div>

        <div
          className='modal-body challenge-modal'
          style={{}}
        >
          <div className='modal-header'>
            <div className=''>
              <ul className='d-flex align-items-center card_tab'>
                <li
                  style={{
                    ...styless.linkStyle,
                    ...(showCompnany
                      ? { borderBottom: '2px solid #1b3665', color: '#7dbf43' }
                      : null),
                  }}
                  onClick={() => {
                    set_showCompany(true);
                    set_showGlobal(false);
                  }}
                >
                  Company
                </li>
                <li
                  style={{
                    ...styless.linkStyle,
                    ...(showGlobal
                      ? { borderBottom: '2px solid #1b3665', color: '#7dbf43' }
                      : null),
                  }}
                  onClick={() => {
                    set_showGlobal(true);
                    set_showCompany(false);
                  }}
                >
                  Global
                </li>
              </ul>
            </div>
            <div style={styless.cancelBtnWrapper} onClick={callback}>
              <img
                src={require('../../../../Assets/Images/Icons/close_icon.png')}
                alt='close'
              />
            </div>
          </div>
          {renderChallengeLists()}
        </div>
      </div>
    </>
  );
};

export default ChallengeModal;
